import {
  Drawer,
  message as messageToast,
} from "antd";
import { CloseSmall } from "@icon-park/react";
import Image from "next/image";
import log_ic_google from "@/app/assets/user/log_ic_google@2x.png"
import log_ic_email from "@/app/assets/user/log_ic_email@2x.png"
import "./style/LoginCarousel.css";
import "./style/LoginForm.css";
import { useRouter } from "next/navigation";
import { getDeviceId, getUserInfo, googleLogin } from "@/service/user";
import { Submit_Status, ThirdLogin } from "@/service/user/enum";
import { useEffect, useState } from "react";
import { BravveSmartButton } from "../common/BravveSmartButton";
import { app, getAuth, GoogleAuthProvider, signInWithPopup } from "@/lib/firebase";
import userInfoStore from "@/store/userInfoStore";

export type LoginProps = {
  open: boolean;
  onClose: () => void;
};

enum privacyPolicy {
  privacyPolicy = 'privacyPolicy',
  termsOfUse = 'termsOfUse'
};

export const Login: React.FC<LoginProps> = ({ open, onClose, ...props }) => {

  const route = useRouter()

  const { setUserInfo } = userInfoStore();

  useEffect(() => {
    queryConfig()
  }, [])

  const [config, setConfig] = useState<any>(null)
  const queryConfig = async () => {
    const { data, code } = await getDeviceId()
    if (code === 0) {
      setConfig(data)
    }
  }

  const gotoSiginAndSignUp = (routeStr: string) => {
    if (!routeStr) return
    route.push(routeStr)
  }

  // 初始化认证实例和谷歌提供方
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();

  // 触发登录函数
  const signInWithGoogle = async () => {
    console.log('触发谷歌登录函数')
    try {
      const result = await signInWithPopup(auth, provider);
      // 登录成功，可以获取用户信息
      callbackGoogleLogin(result)
    } catch (error) {
      // 处理错误
      console.error('登录失败:', error);
    }
  };


  // 处理登录结果
  const callbackGoogleLogin = async (response: any) => {
    console.log("googleLogin: ", response);
    const id_token = response?._tokenResponse?.oauthIdToken;
    if (!id_token) return messageToast.error("Google login failed, please try again later");
    const { code, message } = await googleLogin({ idToken: id_token });
    let gtagObj = {
      oauth_result: ThirdLogin.Google,
      status: code === 0 ? Submit_Status.success : Submit_Status.fail,
    } as {
      oauth_result: ThirdLogin;
      status: Submit_Status;
      fail_reason?: string;
    };

    if (code != 0) {
      gtagObj.fail_reason = message;
    }

    if (code === 0) {
      queryUserInfo();
      console.log("googleLogin data: ", message);
      // @ts-ignore
      if(globalThis?.googleLoginOK) {
        // @ts-ignore
        globalThis.googleLoginOK(gtagObj);
        // @ts-ignore
        delete globalThis.googleLoginOK;
      }
    } else {
      messageToast.error(message);
    }
  };

  /**
    * 获取用户信息
    */
  const queryUserInfo = async () => {
    const { status, data } = await getUserInfo();
    console.log("userInfo: ", status, data);
    if (status === "SUCCESS") {
      setUserInfo(data);
      onClose();
    }
  }

  const openPrivacy_url = (type?: string) => {
    switch (type) {
      case privacyPolicy.privacyPolicy:
        window.open(
          config?.privacy_url,
          "_blank",
          "noopener,noreferrer",
        );
        break;
      case privacyPolicy.termsOfUse:
        window.open(
          config?.terms_of_use_url,
          "_blank",
          "noopener,noreferrer",
        )
    }
  };

  return (
    <Drawer
      className="userLoginDrawer"
      title={<div className="text-bravve-200 text-[1.8rem] font-bold text-center">Quickly Login</div>}
      open={open}
      onClose={() => {
        onClose();
      }}
      // getContainer={false}
      closeIcon={false}
      placement={"bottom"}
      height={"31rem"}
      extra={<CloseSmall theme="filled" fill="#A6A2B9" size={"2.8rem"} onClick={onClose} />}
      styles={{
        header: {
          paddingRight: "1rem",
          height: '5rem',
        },
        body: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "2rem",
        },
      }}
    >
      <div className="flex w-full flex-col items-center">
        <BravveSmartButton
          time={1000}
          size="large"
          style={{ backgroundColor: "transparent", border: "none", boxShadow: "none", padding: 0 }}
          onClick={signInWithGoogle}
          className="relative flex w-full g_id_signin"
        >
          <div className="h-[4.4rem] w-full rounded-[4.2rem] bg-[#2C6CD4] flex items-center justify-center text-[1.5rem] text-white font-bold gap-[.5rem]">
            <Image
              src={log_ic_google}
              width={30}
              height={30}
              alt={"log_ic_google"}
            />
            Log in with Google
          </div>
        </BravveSmartButton>
        <div onClick={() => gotoSiginAndSignUp('/sign-in')} className="h-[4.4rem] w-full rounded-[4.2rem] bg-[#D55B5B] flex items-center justify-center mt-[2rem] text-[1.5rem] text-white font-bold gap-[.5rem]">
          <Image
            src={log_ic_email}
            width={30}
            height={30}
            alt={"log_ic_email"}
          />
          Log in with Email
        </div>
        <div className="flex items-center justify-center gap-[1.5rem] mt-[2.8rem]">
          <div className="text-[1.4rem] text-white opacity-50">Do not have an account?</div>
          <div onClick={() => gotoSiginAndSignUp('/sign-up')} className="text-[1.4rem] text-[#43B1B5] underline">Sign Up</div>
        </div>
        <div className="text-[1.4rem] text-white opacity-50 mt-[1.8rem]">By logging in, you agree to our</div>
        <div className="flex items-center justify-center gap-[1.5rem]">
          <div onClick={() => openPrivacy_url(privacyPolicy.termsOfUse)} className="text-[1.4rem] text-[#43B1B5] underline">Terms of use</div>
          <div className="text-[1.4rem] text-white opacity-50">and</div>
          <div onClick={() => openPrivacy_url(privacyPolicy.privacyPolicy)} className="text-[1.4rem] text-[#43B1B5] underline">Privacy Policy</div>
        </div>
      </div>
    </Drawer>
  );
};
